import { CouponCreate, CouponEdit, CouponList } from 'pages/sales/coupons';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'coupons',
  label: 'Cupons',
  list: CouponList,
  create: CouponCreate,
  edit: CouponEdit,
  actions: ['list', 'show', 'edit', 'create'],
  parentName: 'sales'
};

export default generateResources(resource);
